import { Separator } from '@carboncopyco/ui';
import classNames from 'classnames';
import type { ReactNode } from 'react';

type AssetTableRowProps = {
  children: ReactNode;
  onRowClick?: () => void;
  size?: keyof typeof paddingClasses;
  separator?: boolean;
};

const paddingClasses = {
  sm: 'py-2',
  md: 'py-3',
  lg: 'py-6',
};

export const RowWrapper = ({
  children,
  onRowClick,
  size = 'sm',
  separator,
}: AssetTableRowProps) => (
  <div
    className={classNames('flex flex-col overflow-hidden', {
      'hover:bg-ds-natural-50 cursor-pointer': onRowClick,
    })}
    onClick={onRowClick}
  >
    <div className={paddingClasses[size]}>{children}</div>
    {separator && <Separator horizontal />}
  </div>
);
